import { LoadingAnimation } from 'components/loading/LoadingAnimation';

function GlobalLoader({ loading }: { loading: boolean }) {
  return (
    <div
      className={`fixed inset-0 z-[1300] bg-white/50 backdrop-blur-sm flex items-center justify-center ${
        loading ? '' : 'hidden'
      }`}
    >
      <LoadingAnimation size="large" />
    </div>
  );
}

export { GlobalLoader };
